<template>
  <div class="html">
    <banner
      :title="title"
      :content="content"
    />
    <div class="introduce">
      <p class="sub_title">
        产品简介
      </p>
      <div class="content_A">
        灵创网络安全及信息化能力提升系统凭借其卓越的功能设计和强大的优势，为企业提供了一站式的在线学习解决方案。该系统集随时随地学习、高效便捷的培训方式、精准的人才测评以及智能课程推荐于一体，助力企业快速构建全面、系统且富有互动性的线上课程体系。
      </div>
      <div class="img">
        <img
          src="@/assets/informationization/pic1.png"
          alt=""
        >
      </div>
    </div>

    <div class="introduce">
      <p class="sub_title">
        产品功能及优势
      </p>
      <div
        v-for="fun in functionList"
        :key="fun"
        class="content_A"
      >
        <div>
          <div>{{ fun.title }}</div>
          <div>
            {{ fun.content }}
          </div>
        </div>
        <div class="content_A center_img1">
          <img
            :src="fun.imgUrl"
            alt=""
          >
        </div>
      </div>
    </div>

    <div class="introduce">
      <p class="sub_title">
        用户价值
      </p>
      <div
        v-for="val in valueList"
        :key="val.id"
        class="content_A"
      >
        <div>
          <div class="iconImg center_img1">
            <img
              :src="val.imgUrl"
              alt=""
            >
          </div>
          <div>{{ val.title }}</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import banner from '@/views/securityServices/components/banner.vue'
export default {
  name: 'Risk',
  components: {
    banner
  },
  data() {
    return {
      title: '灵创网络安全及信息化能力提升系统',
      content: '',
      functionList: [
        {
          id: 1,
          title: '碎片整合式学习资源：',
          imgUrl: require('@/assets/informationization/pic2.png'),
          content:
            '多元化培训内容涵盖音视频、图文及文字等格式，员工可以利用碎片时间进行便捷高效的学习；'
        },
        {
          id: 2,
          title: '测训考一体智能化培养：',
          imgUrl: require('@/assets/informationization/pic3.png'),
          content:
            '结合“智能测评”+“精准课程推荐”，实现全方位、智能化的人才培养路径；'
        },
        {
          id: 3,
          title: '灵活部署选项：',
          imgUrl: require('@/assets/informationization/pic4.png'),
          content:
            '针对不同企业需求，我们提供通用SaaS版（开通即用，无需部署运维）、私有云版（支持私有服务器部署，深度定制及源码开放）等多种版本选择；'
        },
        {
          id: 4,
          title: '课程体系搭建高效快捷：',
          imgUrl: require('@/assets/informationization/pic5.png'),
          content:
            '系统具备整合行业关键岗位专业资源的能力，能够创建体系化的课程结构，同时联合优质IP共创精品项目，形成三位一体的智慧运营模式——云平台（全场景培训）、云内容（海量精品资源）和云服务（一站式运营）；'
        },
        {
          id: 5,
          title: '互动式学习工具与效果追踪：',
          imgUrl: require('@/assets/informationization/pic6.png'),
          content:
            '支持打卡、学练考一体化，配备题库、考试、证书、作业本等强互动教学工具，紧密跟踪学习进度和成果，确保扎实掌握知识技能；'
        }
      ],
      valueList: [
        {
          id: 1,
          title: '业务层面：显著提升员工岗位胜任力，确保业务目标达成；通过优化培训流程，有效降低管理成本，定向培养关键人才；',
          imgUrl: require('@/assets/informationization/pic7.png')

        },
        {
          id: 2,
          title: '组织效能：实施降本增效策略，强化企业的生存发展能力，同时提高人才竞争力与生产力；',
          imgUrl: require('@/assets/informationization/pic8.png')
        },
        {
          id: 3,
          title: '数字化流程管理：创新引入趣味闯关设计，实时追踪培训进程，使培训效果可视化，形成完整、系统的培训闭环；',
          imgUrl: require('@/assets/informationization/pic9.png')

        },
        {
          id: 4,
          title: '社区化知识管理：建立完善的组织知识库，连接知识与个体，沉淀实践经验，充分激活知识对业务的驱动作用；',
          imgUrl: require('@/assets/informationization/pic10.png')

        },
        {
          id: 5,
          title: '高性价比应用：采用软件即服务模式，无需额外开发下载，一键开通即可在手机、电脑等多终端同步使用，大大节省开发成本，实现卓越性价比投入。',
          imgUrl: require('@/assets/informationization/pic11.png')

        }
      ]
    }
  }
}
</script>

<style scoped>
@import '../../styles/utils.scss';
.img{
  display: flex;
  justify-content: center;
}
.center_img1 {
  display: flex;
  justify-content: center;
  margin-bottom: 20px;
}
.center_img1 img{
  max-width: 60%;
}
.img img{
 width: 70%;
}
</style>
